/**
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   index.ts
 */

import type { User } from '@zcode/bizos'
import {
  ADD_BUTTER_BAR,
  ON_MESSAGE_SENT,
  REMOVE_BUTTER_BAR,
  SET_LOCAL_USER,
  SET_USER,
} from './constants'

export function setUser({ user }: { user: User }) {
  return {
    type: SET_USER,
    user,
  }
}

export function setLocalUser(user: User) {
  return {
    type: SET_LOCAL_USER,
    user,
  }
}

export function showButterBar(butterBar = {}) {
  return {
    type: ADD_BUTTER_BAR,
    butterBar,
  }
}

export function removeButterBar(butterBarId: number) {
  return {
    type: REMOVE_BUTTER_BAR,
    butterBarId,
  }
}

export type OnMessageSentPayload =
  | {
      readonly buildingIds?: never
      readonly equalCTAIntent?: never
      readonly listingIds?: never
      readonly success: false
      readonly timestamp?: never
    }
  | {
      readonly buildingIds: readonly number[] | undefined
      readonly success: true
      readonly equalCTAIntent: 'Apply' | 'Message' | 'Tour' | 'Waitlist' | undefined
      readonly listingIds: readonly number[] | undefined
      /** in seconds */
      readonly timestamp: number
    }

export function onMessageSent({
  success,
  buildingIds,
  equalCTAIntent,
  listingIds,
  timestamp,
}: OnMessageSentPayload) {
  return success
    ? ({
        type: ON_MESSAGE_SENT,
        success,
        buildingIds,
        equalCTAIntent,
        listingIds,
        timestamp,
      } as const)
    : ({
        type: ON_MESSAGE_SENT,
        success,
        buildingIds,
        equalCTAIntent,
        listingIds,
        timestamp,
      } as const)
}
